import { ValidateCertificateInput, ValidateCertificateOutput } from './../../../../shared/service-proxies/service-proxies';
import { Component, ViewEncapsulation, Injector, ViewChild, OnInit } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CertificateModalComponent } from '@app/event/my-registrations/modal/certificate-modal.component';

import * as _ from 'lodash';
import { CertificatesServiceProxy, RegistrationsServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
    templateUrl: './validate.component.html',
    styleUrls: ['./validate.component.css'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class ValidateCertificateComponent extends AppComponentBase implements OnInit {

    registrationId = 0;
    userId = 0;

    saving = false;
    showButton = true;
    validation: ValidateCertificateOutput;
    loaded = false;

    constructor(
        injector: Injector,
        private _router: Router,
        private _registrationsService: RegistrationsServiceProxy,
        private _certificatesService: CertificatesServiceProxy,
        private activatedRoute: ActivatedRoute
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.registrationId = +params['registrationId'];
            this.userId = +params['userId'];

            this.validate();
        });

        this.block('.m-portlet');

    }

    validate(): void {
        let input = new ValidateCertificateInput();
        input.registrationId = this.registrationId;
        input.userId = this.userId;

        this._certificatesService
            .validate(input)
            .finally(() => {
                this.unBlock('.m-portlet');
            })
            .subscribe(result => {
                if (result) {
                    this.validation = result;
                }

                this.loaded = true;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/certificate/validate/validate.component.ts